// extracted by mini-css-extract-plugin
module.exports = {"VisualSearchContainer":"visualsearch_VisualSearchContainer__jm5Jl"};